import { render, staticRenderFns } from "./GridHeader.vue?vue&type=template&id=97054a8c"
import script from "./GridHeader.vue?vue&type=script&lang=js"
export * from "./GridHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports